import { SOCIAL_LINKS, TOUR_VIDEO } from "@/data/networks";

const API = process.env.REACT_APP_BACKEND_URL;

// Pulls owner-managed values (real profile URLs, tour video ID) and applies them
// in place so every component that reads SOCIAL_LINKS / TOUR_VIDEO sees the real thing.
export const applySettings = (s) => {
  Object.assign(SOCIAL_LINKS, s.social || {});
  if (s.youtubeId) TOUR_VIDEO.youtubeId = s.youtubeId;
};

export const loadSettings = async () => {
  try {
    const r = await fetch(`${API}/api/settings`);
    if (r.ok) applySettings(await r.json());
  } catch {
    /* keep placeholders */
  }
};
